<template>
    <div style="height: 100% !important;">
<v-tabs vertical style="height: 100%;">
<div class="text-left pa-6 logo">
                <div>
                    <img :src="require('@/assets/image/admin_logo.png')">
                    <span class="pl-1">TN-BOX</span>
                </div>
                <div class="mt-2">
Admin
</div>
            </div>

            <div class="mt-2" style="height: 100% !important;">
                <v-tab>
                    <v-icon left>
mdi-account
</v-icon>
                    공지사항
                </v-tab>
                <v-tab>
                    <v-icon left>
mdi-lock
</v-icon>
                    다국어 관리
                </v-tab>
                <v-tab>
                    <v-icon left>
mdi-access-point
</v-icon>
                    회원관리
                </v-tab>
            </div>

            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <div class="title pb-13">
공지사항
</div>
                        <div class="pb-5 button_wrap notice">
                            <div class="d-inline-flex">
                                <v-select
                                        label="국가 선택"
                                        outlined
                                />
                                <v-select
                                        :items="items"
                                        label="구분 선택"
                                        outlined
                                />
                                <v-select
                                        :items="items"
                                        label="게시 여부"
                                        outlined
                                />
                            </div>
                            <div class="d-inline-flex">
                                <v-text-field
                                        :placeholder="'검색'"
                                        append-icon="mdi-magnify"
                                        dense
                                        outlined
                                        background-color="white"
                                        hide-details
                                        single-line
                                        style="width: 550px;"
                                />
                            </div>
                        </div>
                        <v-data-table
                                v-model="selected"
                                :headers="noticeHeaders"
                                :items="noticeContext"
                                item-key="language"
                                show-select
                                class="elevation-1"
                                flat
                        />
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <div class="title pb-13">
다국어 관리
</div>
                        <div class="pb-5 button_wrap">
                            <div class="d-inline-flex">
                                <v-btn outlined>
다국어 추가 (한글)
</v-btn>
                                <v-btn outlined>
선택 일괄 삭제
</v-btn>
                                <v-btn outlined>
일괄 업데이트
</v-btn>
                            </div>
                            <div class="d-inline-flex">
                                <v-btn outlined>
중복된것 보기
</v-btn>
                                <v-btn outlined>
미번역된것 보기
</v-btn>
                                <v-text-field
                                        :placeholder="'검색'"
                                        append-icon="mdi-magnify"
                                        dense
                                        outlined
                                        background-color="white"
                                        hide-details
                                        single-line
                                        style="width: 550px;"
                                />
                            </div>
                        </div>
                        <v-data-table
                                v-model="selected"
                                :headers="headers"
                                :items="context"
                                item-key="language"
                                show-select
                                class="elevation-1"
                                flat
                        />
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <div class="title pb-13">
회원관리
</div>
                        <div class="pb-5 button_wrap membership">
                            <div class="d-inline-flex">
                                <v-select
                                        :items="items"
                                        label="그룹사"
                                        outlined
                                />
                                <v-select
                                        :items="items"
                                        label="국가 선택"
                                        outlined
                                />
                                <v-select
                                        :items="items"
                                        label="승인 여부"
                                        outlined
                                />
                                <v-select
                                        :items="items"
                                        label="CMS사용"
                                        outlined
                                />
                                <v-select
                                        :items="items"
                                        label="세금계산서"
                                        outlined
                                />
                            </div>
                            <div class="d-inline-flex">
                                <v-text-field
                                        :placeholder="'검색'"
                                        append-icon="mdi-magnify"
                                        dense
                                        outlined
                                        background-color="white"
                                        hide-details
                                        single-line
                                        style="width: 550px;"
                                />
                            </div>
                        </div>
                        <v-data-table
                                v-model="selected"
                                :headers="membershipHeaders"
                                :items="membershipContext"
                                item-key="language"
                                show-select
                                class="elevation-1"
                                flat
                        />
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>
</div>
</template>

<script>
    export default {
        name: "MainFrame",
        props: {
            range: Number,
            rangeBetween: Number,
            bias: String,
            start: null,
            end: null,
            min: null,
            max: null,
        },
        data() {
            return {
                tab: null,
                tabs: 3,
                selected: [],
                noticeHeaders: [
                    {
                        text: '번호',
                        align: 'start',
                        value: 'index',
                    },
                    {
                        text: '제목',
                        value: 'title',
                    },
                    {
                        text: '국가',
                        value: 'country',
                    },
                    {
                        text: '구분',
                        value: 'division',
                    },
                    {
                        text: '게시 여부(팝업공지)',
                        value: 'Whether',
                    },
                    {
                        text: '게시 시작일(팝업공지)',
                        value: 'start',
                    },
                    {
                        text: '게시 종료일(팝업공지)',
                        value: 'end',
                    },
                    {
                        text: '작성자',
                        value: 'Writer',
                    }
                    , {
                        text: '등록일자',
                        value: 'registration',
                    }
                ],
                noticeContext: [
                    {
                        index: '1',
                        title: 'J3570 복합기',
                        country: 'KR',
                        division: '제품정보',
                        Whether: 'Y',
                        start: '2020-06-17',
                        end: '2020-09-30',
                        writer: 'admin',
                        registration: '2020-06-17'
                    },
                    {
                        index: '2',
                        title: 'EPSON C5790',
                        country: 'KR',
                        division: '제품정보',
                        Whether: 'Y',
                        start: '2020-06-1',
                        end: '2020-06-30',
                        writer: 'admin',
                        registration: '2020-06-11'
                    }
                ],
                headers: [
                    {
                        text: '언어',
                        align: 'start',
                        value: 'language',
                    },
                    {text: '메시지키', value: 'messagekey'},
                    {text: '메시지', value: 'message'},
                    {text: '그룹키', value: 'groupkey'},
                    {text: '등록일자', value: 'register'},
                    {text: '수정일자', value: 'modified'},
                ],
                context: [
                    {
                        language: 'ko-KR',
                        messagekey: '계속 진행 하시겠습니까?',
                        message: '계속 진행 하시겠습니까?',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '이용약관',
                        message: '이용약관',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '프린터 등록대수',
                        message: '프린터 등록대수',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '계산 시작일',
                        message: '계산 시작일',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '월별 사용량 추가',
                        message: '월별 사용량 추가',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '처리결과',
                        message: '처리결과',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '최근 A/S이력',
                        message: '최근 A/S이력',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '증상상세',
                        message: '증상상세',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '변경된 순서 적용',
                        message: '변경된 순서 적용',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                    {
                        language: 'ko-KR',
                        messagekey: '관련 통장',
                        message: '관련 통장',
                        groupkey: 'g',
                        register: '2020-08-14',
                        modified: '2020-08-14',
                    },
                ],
                membershipHeaders: [
                    {
                        text:'번호',
                        value: 'index',
                    },
                    {
                        text:'업체코드',
                        value: 'code',
                    },
                    {
                        text:'사업자번호',
                        value: 'businessNumber',
                    },
                    {
                        text:'대표자명',
                        value: 'Representative',
                    },
                    {
                        text:'전화번호',
                        value: 'phone',
                    },
                    {
                        text:'그룹사',
                        value: 'groupCompanies',
                    },
                    {
                        text:'등록일자',
                        value: 'registrationDate',
                    },
                    {
                        text:'승인',
                        value: 'admission',
                    },
                    {
                        text:'장치(수집기)',
                        value: 'device',
                    },
                    {
                        text:'pc(수집기)',
                        value: 'pc',
                    },
                    {
                        text:'국가',
                        value: 'country',
                    },
                    {
                        text:'시간대',
                        value: 'time',
                    },
                    {
                        text:'통화',
                        value: 'currency',
                    },
                    {
                        text:'효성(cms)',
                        value: 'hyosung',
                    },
                    {
                        text:'나이스(cms)',
                        value: 'nice',
                    },
                    {
                        text:'전자세금계산서',
                        value: 'tax',
                    },
                    {
                        text:'잉크잔량(%)',
                        value: 'ink',
                    },
                    {
                        text:'장치(응답시간)',
                        value: 'deviceTime',
                    },
                    {
                        text:'프린터(응답시간)',
                        value: 'printerTime',
                    },
                    {
                        text:'이메일',
                        value: 'email',
                    },
                    {
                        text:'주소',
                        value: 'address',
                    },

                ],
                membershipContext: [
                    {
                        index: '1',
                        code: '1000129',
                        businessNumber: '456782513',
                        Representative: '도경민',
                        phone: '010-2456-9852',
                        groupCompanies: 'MBOX',
                        registrationDate: '2020-08-12',
                        admission: 'Y',
                        device: '0',
                        pc: '0',
                        country: '대한민국',
                        time: '+09:00(Seiul)',
                        currency: 'KRW',
                        hyosung: 'Y',
                        nice: 'Y',
                        tax:'Y',
                        ink:'15',
                        deviceTime:'120',
                        printerTime:'1440',
                        email: 'kjj@tinteccnc.com',
                        address:'서울특별시 강서구 마곡중앙2로'
                    }
                ]
            }
        },
    }
</script>

<style scoped>
    /*vertical side bar start*/
    >>> .v-tabs--vertical > .v-tabs-bar {
        width: 380px;
    }

    .v-tab.v-tab {
        justify-content: flex-start;
        color: white;
    }


    >>> .theme--light.v-tabs > .v-tabs-bar {
        background-color: #2B3F54;
    }

    .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
        color: white;
    }

    .v-tab:before {
        width: 380px;
    }

    >>> .v-tab {
        max-width: 380px !important;
    }

    /* 사이드바 메뉴 호버, 클릭시 화살표 나타나야함
    .v-tab:hover{
        background-image: url("/image/right_arrow.png");
    }
    */

    .logo {
        height: 110px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15)
    }

    .logo > div > span {
        color: white;
        font-weight: bold;
        font-size: 14px;
    }

    .logo > div:nth-child(2) {
        color: white;
        font-weight: bold;
        font-size: 24px;
    }

    >>> html {
        height: 100% !important;
    }

    >>> body {
        height: 100% !important;
    }

    >>> v-tabs v-tabs--vertical theme--light {
        height: 100%;
    }

    /*vertical side bar end*/


    /*공지사항 contents start*/

    .notice {
        height: 60px;
    }

    /*공지사항 contents end*/


    /*다국어 관리 table contents start*/

    >>> .v-data-table-header {
        background-color: #f8f8f8;
    }

    >>> .title {
        font-size: 34px !important;
        font-weight: bold;
    }

    .button_wrap {
        display: flex;
        justify-content: space-between;
    }

    .theme--light.v-btn:hover {
        color: #0C98FE;
    }

    .theme--light.v-btn:active {
        color: #0C98FE;
    }

    .button_wrap div .v-btn {
        margin-right: 8px;
        height: 40px;
    }

    >>> .v-card__text {
        padding-top: 80px;
        text-align: left
    }

    >>> .v-data-footer {
        display: none;
    }

    /*table contents end*/

    /*공지사항 contents start*/

    .notice {
        height: 60px;
    }

    /*공지사항 contents end*/

    /*회원관리 contents start*/

    .v-input {
        max-width: 188px;
    }

    .membership {
        height: 60px;
    }

    /*회원관리 contents end*/
</style>